import { RoutePath, type RoutePaths } from "@/lib/routes"

const apiRoutePath = RoutePath.create("/api")

const apiAccountRoutePath = apiRoutePath.create("/account")
const apiAccountRoutesPaths = {
    addCampaignToAccount: apiAccountRoutePath.create("/add-campaign-to-account"),
    createAccount: apiAccountRoutePath.create("/create-account"),
    createMetadata: apiAccountRoutePath.create("/create-metadata"),
} as const

const authApiRoutePath = apiRoutePath.create("/auth")
const authApiRoutesPaths = {
    login: authApiRoutePath.create("/login"),
    logout: authApiRoutePath.create("/logout"),
    session: authApiRoutePath.create("/session"),
} as const

const partnerAuthApiRoutePath = authApiRoutePath.create("/sso/:partnerSlug")
const partnerAuthApiRoutesPaths = {
    partnerAuthCallback: partnerAuthApiRoutePath.create("/callback"),
    partnerAuthLogout: partnerAuthApiRoutePath.create("/logout"),
} as const

const meeloApiRoutePath = apiRoutePath.create("/meelo")
const meeloApiRoutesPaths = {
    meeloJourneyGenerateLink: meeloApiRoutePath.create("/journeys/:journeyId/generate-link"),
    meeloJourneyLastTask: meeloApiRoutePath.create("/journeys/:journeyId/last-task"),
    meeloWebhook: meeloApiRoutePath.create("/webhook"),
} as const

const onboardingApiRoutePath = apiRoutePath.create("/onboarding")
const onboardingApiRoutesPaths = {
    bankingAssessment: onboardingApiRoutePath.create("/banking-assessment"),
    checkMeterPointEligibility: onboardingApiRoutePath.create("/check-meter-point-eligibility"),
    computeEnergyLandscape: onboardingApiRoutePath.create("/compute-energy-landscape"),
    createAccountNote: onboardingApiRoutePath.create("/create-account-note"),
    eligibilityCheckQuote: onboardingApiRoutePath.create("/eligibility-check-quote"),
    enrollNewAccount: onboardingApiRoutePath.create("/enroll-new-account"),
    enrollment: onboardingApiRoutePath.create("/enrollment"),
    fraudsterDetection: onboardingApiRoutePath.create("/fraudster-detection"),
    joinSupplierAcceptTermsAndConditions: onboardingApiRoutePath.create(
        "/join-supplier-accept-terms-and-conditions"
    ),
    recordEffyLeadSubscription: onboardingApiRoutePath.create("/record-effy-lead-subscription"),
    selectProducts: onboardingApiRoutePath.create("/select-products"),
    sendQuote: onboardingApiRoutePath.create("/send-quote"),
    updateUserDetailsDepositType: onboardingApiRoutePath.create(
        "/update-user-details-deposit-type"
    ),
} as const

const paymentInstructionApiRoutePath = apiRoutePath.create("/payment-instruction")
const paymentInstructionApiRoutesPaths = {
    paymentInstructionGenerateSecret: paymentInstructionApiRoutePath.create("/generate-secret"),
} as const

const wizardApiRoutePath = apiRoutePath.create("/wizard")
const wizardApiRoutesPaths = {
    submitForm: wizardApiRoutePath.create("/submit-form"),
} as const

export const apiRoutesPaths = {
    graphql: {
        kraken: apiRoutePath.create("/graphql/kraken"),
        oeBackend: apiRoutePath.create("/graphql/oe-backend"),
    },
    invalidatePreSignedToken: apiRoutePath.create("/invalidate-pre-signed-token"),
    ...apiAccountRoutesPaths,
    ...authApiRoutesPaths,
    ...partnerAuthApiRoutesPaths,
    ...meeloApiRoutesPaths,
    ...onboardingApiRoutesPaths,
    ...paymentInstructionApiRoutesPaths,
    ...wizardApiRoutesPaths,
} as const satisfies RoutePaths
